module.exports = __webpack_public_path__ + "img/FCN.1f77cb9d.svg";